module.exports = __webpack_public_path__ + "img/csvgg.3ed4174b.gif";